import HexController from 'controllers/hex_controller';

/*
  @author: iacopo.carraro@hexawise.com
  @description: This controller is used to handle the tabs on the auto script page.
  It has 2 different behaviours:
  - use direct links and set the 'selected' class for the tab header and the content directly in the HTML
  - use the controller to change the tab using the changeTab action
  @version: 1.0.0
  @since: 2025-03-04
*/
export default class extends HexController {
  static targets = ['tab', 'content'];
  static values = {
    active: {
      type: Number,
      default: 0,
    },
    autoInit: {
      type: Boolean,
      default: false,
    },
  };

  connect() {
    if (this.autoInitValue) {
      this._changeTab(this.activeValue);
    }
    // Show the active tab
    const activeTab = this.tabWithIndex(this.activeValue);
    if (activeTab) {
      activeTab.scrollIntoView();
    }
  }

  changeTab(event) {
    const tab = event.target.closest('.hex-tab');
    const index = tab.dataset.index;
    event.preventDefault();
    this._changeTab(index);
  }

  _changeTab(index) {
    if (this.activeValue !== undefined) {
      this.tabWithIndex(this.activeValue).classList.remove('selected');
      this.contentWithIndex(this.activeValue).classList.remove('selected');
    }
    this.tabWithIndex(index).classList.add('selected');
    this.contentWithIndex(index).classList.add('selected');
    this.activeValue = index;
  }

  tabWithIndex(index) {
    return this.tabTargets.find((tab) => tab.dataset.index === index.toString());
  }

  contentWithIndex(index) {
    return this.contentTargets.find((content) => content.dataset.index === index.toString());
  }
}
